import {useAuthStore} from "../store/user-store";

export default function VipPage() {
    const authStore=useAuthStore();

    return (
        <div className={'container'}>
<div className="row justify-content-center">
    <div className="col-md-6">
        <div className="d-flex flex-column justify-content-center align-items-center gap-3">
            <h3 className={'text-white border-botom-white'}>فئات الأسعار في الموقع</h3>
            <p className={'text-white text-center'}>شريحتك الحالية هي <span className={'text-orange'}> {authStore.user?.group=='group1' ?authStore.settings?.label1 :
                authStore.user?.group=='group2'?authStore.settings?.label2: authStore.user?.group=='group3' ? authStore.settings?.label3 :authStore.user?.group=='group4'?authStore.settings?.label4:authStore.user?.group=='group5'?authStore.settings?.label5:authStore.settings?.label6

            } </span> إذا كنت ترغب بترقية حسابك إلى شريحة أعلى والحصول على حسومات مميزة ما عليك إلا زيادة مبيعاتك</p>
            <div className="d-flex flex-row justify-content-center align-items-center">
                <img style={{width:50,height:50}} src={authStore.settings?.vip1} alt=""/>
                <span className={'text-white h5'}>{authStore.settings?.label1}</span>
                {authStore.user?.id==null || authStore.user?.group!='group1'?
                    <i className="fa fa-lock mx-2 fa-2x text-orange"></i>
                    :<i className="fa fa-lock-open mx-2 fa-2x text-success"></i>}
            </div>
            <div className="d-flex flex-row justify-content-center align-items-center">
                <img style={{width:50,height:50}} src={authStore.settings?.vip2} alt=""/>
                <span className={'text-white h5'}>{authStore.settings?.label2}</span>
                {authStore.user?.id==null || authStore.user?.group!='group2'?
                    <i className="fa fa-lock mx-2 fa-2x text-orange"></i>
                    :<i className="fa fa-lock-open mx-2 fa-2x text-success"></i>}
            </div>

            <div className="d-flex flex-row justify-content-center align-items-center">
                <img style={{width:50,height:50}} src={authStore.settings?.vip3} alt=""/>
                <span className={'text-white h5'}>{authStore.settings?.label3}</span>
                {authStore.user?.id==null || authStore.user?.group!='group3'?
                    <i className="fa fa-lock mx-2 fa-2x text-orange"></i>
                    :<i className="fa fa-lock-open mx-2 fa-2x text-success"></i>}
            </div>

            <div className="d-flex flex-row justify-content-center align-items-center">
                <img style={{width:50,height:50}} src={authStore.settings?.vip4} alt=""/>
                <span className={'text-white h5'}>{authStore.settings?.label4}</span>
                {authStore.user?.id==null || authStore.user?.group!='group4'?
                    <i className="fa fa-lock mx-2 fa-2x text-orange"></i>
                    :<i className="fa fa-lock-open mx-2 fa-2x text-success"></i>}
            </div>

            <div className="d-flex flex-row justify-content-center align-items-center">
                <img style={{width:50,height:50}} src={authStore.settings?.vip5} alt=""/>
                <span className={'text-white h5'}>{authStore.settings?.label5}</span>
                {authStore.user?.id==null || authStore.user?.group!='group5'?
                    <i className="fa fa-lock mx-2 fa-2x text-orange"></i>
                    :<i className="fa fa-lock-open mx-2 fa-2x text-success"></i>}
            </div>

            <div className="d-flex flex-row justify-content-center align-items-center">
                <img style={{width:50,height:50}} src={authStore.settings?.vip6} alt=""/>
                <span className={'text-white h5'}>{authStore.settings?.label6}</span>
                {authStore.user?.id==null || authStore.user?.group!='group6'?
                    <i className="fa fa-lock mx-2 fa-2x text-orange"></i>
                    :<i className="fa fa-lock-open mx-2 fa-2x text-success"></i>}
            </div>
        </div>
    </div>
</div>
        </div>
    )
}